export default function Logo({ size = 32 }) {
  return (
    <img
      src="/tf_logo.png"
      alt="TargetFunder"
      style={{ height: size }}
      className="object-contain w-auto"
    />
  );
}
